"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTestId = void 0;
var DataTestId;
(function (DataTestId) {
    // PreQualificationMoapHelocRefiV2.vue
    DataTestId["preQualInfoHelocRefiTitle"] = "prequal-info-heloc-refi-title";
    DataTestId["preQualInfoHelocRefiOffer"] = "prequal-info-heloc-refi-offer";
    DataTestId["preQualInfoOptionsHelocRefiCreditLimit"] = "prequal-info-options-heloc-refi-credit-limit";
    DataTestId["preQualInfoOptionsHelocRefiVarApr"] = "prequal-info-options-heloc-refi-var-apr";
    DataTestId["preQualInfoOptionsHelocRefiCashBack"] = "prequal-info-options-heloc-refi-cash-back";
    DataTestId["preQualInfoOptionsHelocRefiMaturityPeriodYears"] = "prequal-info-options-heloc-refi-maturity-period-years";
    DataTestId["preQualInfoOptionsHelocRefiPayoffFee"] = "prequal-info-options-heloc-refi-payoff-fee";
    DataTestId["preQualInfoOptionsHelocRefiTransferAmount"] = "prequal-info-options-heloc-refi-transfer-amount";
    // HelocRefiAprSection.vue
    DataTestId["preQualInfoOptionsHelocRefiApr"] = "prequal-info-options-heloc-refi-apr";
    DataTestId["preQualInfoOptionsHelocRefiTeaserApr"] = "prequal-info-options-heloc-refi-teaser-apr";
    DataTestId["preQualInfoOptionsHelocRefiRegularApr"] = "prequal-info-options-heloc-refi-regular-apr";
    // HelocRefiMonthlyPaymentSection.vue
    DataTestId["preQualInfoOptionsHelocRefiTeaserMonthlyPayment"] = "prequal-info-options-heloc-refi-teaser-monthly-payment";
    DataTestId["preQualInfoOptionsHelocRefiAfterTeaserMonthlyPayment"] = "prequal-info-options-heloc-refi-after-teaser-monthly-payment";
    DataTestId["preQualInfoOptionsHelocRefiSecondLienMonthlyPayment"] = "prequal-info-options-heloc-refi-second-lien-monthly-payment";
    DataTestId["preQualInfoOptionsHelocRefiMonthlyPayment"] = "prequal-info-options-heloc-refi-monthly-payment";
    DataTestId["preQualInfoOptionsHelocRefiMonthlyPaymentDecrease"] = "prequal-info-options-heloc-refi-monthly-payment-decrease";
    // HelocRefiFinalOffer.vue
    DataTestId["helocRefiFinalOffer"] = "heloc-refi-final-offer";
    DataTestId["helocRefiFinalOfferCreditLimit"] = "heloc-refi-final-offer-credit-limit";
    DataTestId["helocRefiFinalOfferVarApr"] = "heloc-refi-final-offer-var-apr";
    DataTestId["helocRefiFinalOfferCashback"] = "heloc-refi-final-offer-cashback";
    DataTestId["helocRefiFinalOfferPayoffFee"] = "heloc-refi-final-offer-payoff-fee";
    DataTestId["helocRefiFinalOfferTransferAmount"] = "heloc-refi-final-offer-transfer-amount";
    DataTestId["helocRefiFinalOfferApr"] = "heloc-refi-final-offer-apr";
    DataTestId["helocRefiFinalOfferTeaserMonthlyPayment"] = "heloc-refi-final-offer-teaser-monthly-payment";
    DataTestId["helocRefiFinalOfferAfterTeaserMonthlyPayment"] = "heloc-refi-final-offer-after-teaser-monthly-payment";
    DataTestId["helocRefiFinalOfferMonthlyPayment"] = "heloc-refi-final-offer-monthly-payment";
    // aven_frontend/aven/src/components/HelocRefiOffer.vue
    DataTestId["productDetailsLineSize"] = "product-details-line-size";
    DataTestId["productDetailsVariableApr"] = "product-details-variable-apr";
    DataTestId["productDetailsPayoffFee"] = "product-details-payoff-fee";
    DataTestId["productDetailsPayoffAmount"] = "product-details-payoff-amount";
    DataTestId["productDetailsPayoffAmountWithoutFee"] = "product-details-payoff-amount-without-fee";
    DataTestId["productDetailsPayoffFeeAmount"] = "product-details-payoff-fee-amount";
    DataTestId["productDetailsFixedApr"] = "product-details-fixed-apr";
    DataTestId["productDetailsSecondLienAttestedMonthlyPayment"] = "product-details-second-lien-attested-monthly-payment";
    DataTestId["productDetailsEstimatedMonthlyPayment"] = "product-details-estimated-monthly-payment";
    // CryptoConfirmOffer.vue
    DataTestId["cryptoConfirmOfferCreditLimit"] = "confirm-offer-credit-limit";
    DataTestId["cryptoConfirmOfferApr"] = "confirm-offer-apr";
    // CryptoUpdateLimitSuccess.vue
    DataTestId["cryptoUpdateLimitSuccessCreditLimit"] = "crypto-update-limit-success-credit-limit";
})(DataTestId || (exports.DataTestId = DataTestId = {}));
